import "../formating/content.css";

export default function SuccessPage() {
  return (
    <div className="successPageMessage">"Jelszavad sikeresen megváltozott!"</div>
  );
}
